class SubscriptionInvoiceHistoryTable implements ng.IComponentController {
    invoicesList: anm.Charge[];
    isExpanded: boolean;

    constructor() {
        this.invoicesList = this.invoicesList.map(invoice => {
            const isSuccess = ['SUCCESS', 'REFUNDED'].includes(invoice.status);
            const status = isSuccess ? invoice.status.toLowerCase() : 'fail';
            const errorMessage = isSuccess ? '' : invoice.status;

            return {
                ...invoice,
                status,
                errorMessage
            };
        });
    }

    getInvoiceUrl(invoiceId: string) {
        return `${options.apiDomain}/subscription/invoice/${invoiceId}`;
    }
}

angular
    .module('animatronApp.SubscriptionInvoiceHistoryTable', [])
    .component('subscriptionInvoiceHistoryTable', {
        bindings: {
            invoicesList: '<'
        },
        controller: SubscriptionInvoiceHistoryTable,
        templateUrl: require('settings/subscription/subscription-invoice-history-table.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionInvoiceHistoryTable.ts